import React, { useState, useEffect, useCallback, useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { serverURL, postData, getData } from "../../../services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const ExportIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const XIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const UserIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const UsersIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const WarningIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const StaffTable = () => {
  const { theme } = useContext(ThemeContext); // ← Theme Context
  
  // ─── STATE ─────────────────────────────────────────────────────
  const [staff, setStaff] = useState([]);
  const [filteredStaff, setFilteredStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedAdmin, setSelectedAdmin] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);
  const [toast, setToast] = useState(null);
  const [apiAvailable, setApiAvailable] = useState(true);
  
  // Modal states
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    role: "",
    adminAccess: "No",
    status: "Active"
  });
  const [roles, setRoles] = useState([
    "Super Admin",
    "Manager",
    "Sales",
    "Support",
    "Neeraj"
  ]);

  // ─── MOCK DATA ─────────────────────────────────────────────────
  const getMockStaff = () => {
    return [
      { id: 1, name: "Rohit Gurjar", email: "rohit@gmail.com", phone: "7089211599", role: "Neeraj", adminAccess: "0", status: "1", createdAt: "2024-01-15" },
      { id: 2, name: "Yash Suri", email: "yash18suri20@gmail.com", phone: "9200018690", role: "Super Admin", adminAccess: "1", status: "1", createdAt: "2024-01-10" },
      { id: 3, name: "Dujesh Khot", email: "dujeshazptodoor@gmail.com", phone: "93019821212", role: "Sales", adminAccess: "0", status: "1", createdAt: "2024-01-20" },
      { id: 4, name: "Ashishika Suri", email: "ashishikazaptodoor@gmail.com", phone: "8370083222", role: "Super Admin", adminAccess: "0", status: "1", createdAt: "2024-01-18" },
      { id: 5, name: "Neeraj Verma", email: "nv912333@gmail.com", phone: "9109747086", role: "Neeraj", adminAccess: "0", status: "1", createdAt: "2024-01-22" },
      { id: 6, name: "Dujesh Khot", email: "dujeshkhot60@gmail.com", phone: "9301982121", role: "Sales", adminAccess: "0", status: "1", createdAt: "2024-01-25" },
      { id: 7, name: "Yash Raj Suri", email: "admin@zaptodoor.com", phone: "9300018690", role: "Super Admin", adminAccess: "1", status: "1", createdAt: "2024-01-05" },
      { id: 8, name: "Shiva", email: "admin@zaptodoor.com", phone: "7781947165", role: "Manager", adminAccess: "1", status: "1", createdAt: "2024-01-28" },
    ];
  };

  // ─── API FUNCTIONS ─────────────────────────────────────────────
  const fetchStaff = useCallback(async () => {
    setLoading(true);
    try {
      const endpoints = [
        "Staff/getStaff",
        "Staff/staff",
        "Staff/list",
        "Staff/all",
        "Staff/getAdmins",
        "Staff/admins"
      ];
      
      let response = null;
      
      for (const endpoint of endpoints) {
        try {
          console.log(`🔄 Trying endpoint: ${endpoint}`);
          response = await getData(endpoint);
          if (response && (response.status === true || Array.isArray(response.data) || Array.isArray(response))) {
            console.log(`✅ Successfully fetched from: ${endpoint}`);
            break;
          }
        } catch (e) {
          console.log(`❌ ${endpoint} failed:`, e.message);
        }
      }
      
      if (response) {
        let staffData = [];
        if (response.status === true && response.data) {
          staffData = Array.isArray(response.data) ? response.data : [];
        } else if (Array.isArray(response)) {
          staffData = response;
        } else if (response.data && Array.isArray(response.data)) {
          staffData = response.data;
        } else if (response.staff && Array.isArray(response.staff)) {
          staffData = response.staff;
        } else if (response.admins && Array.isArray(response.admins)) {
          staffData = response.admins;
        }
        
        if (staffData.length > 0) {
          setStaff(staffData);
          setFilteredStaff(staffData);
          setApiAvailable(true);
          showToast(`Loaded ${staffData.length} staff members`, "success");
        } else {
          const mockData = getMockStaff();
          setStaff(mockData);
          setFilteredStaff(mockData);
          setApiAvailable(false);
          showToast("Using offline data - API returned empty", "warning");
        }
      } else {
        const mockData = getMockStaff();
        setStaff(mockData);
        setFilteredStaff(mockData);
        setApiAvailable(false);
        showToast("Using offline data - API unavailable", "warning");
      }
    } catch (error) {
      console.error("❌ All fetch attempts failed:", error);
      const mockData = getMockStaff();
      setStaff(mockData);
      setFilteredStaff(mockData);
      setApiAvailable(false);
      showToast("Using offline data - API connection failed", "error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStaff();
  }, [fetchStaff]);

  // Filter staff
  useEffect(() => {
    let filtered = [...staff];
    
    if (searchTerm) {
      filtered = filtered.filter(s => 
        s.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        s.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        s.phone?.includes(searchTerm)
      );
    }
    
    if (selectedRole !== "all") {
      filtered = filtered.filter(s => s.role === selectedRole);
    }
    
    if (selectedStatus !== "all") {
      const statusValue = selectedStatus === "Active" ? "1" : "0";
      filtered = filtered.filter(s => s.status === statusValue);
    }
    
    if (selectedAdmin !== "all") {
      const adminValue = selectedAdmin === "Admin" ? "1" : "0";
      filtered = filtered.filter(s => s.adminAccess === adminValue);
    }
    
    setFilteredStaff(filtered);
    setCurrentPage(1);
  }, [searchTerm, selectedRole, selectedStatus, selectedAdmin, staff]);

  // ─── CRUD OPERATIONS ───────────────────────────────────────────
  const addStaff = async () => {
    if (!formData.name || !formData.email || !formData.phone || !formData.role) {
      showToast("Please fill all required fields", "error");
      return;
    }
    
    setActionLoading(true);
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password || "default123",
        role: formData.role,
        adminAccess: formData.adminAccess === "Yes" ? "1" : "0",
        status: formData.status === "Active" ? "1" : "0"
      };
      
      const endpoints = ["Staff/addStaff", "Staff/addAdmin", "Staff/create", "Staff/register"];
      let response = null;
      
      for (const endpoint of endpoints) {
        try {
          response = await postData(endpoint, payload);
          if (response && response.status === true) {
            console.log(`✅ Staff added via ${endpoint}`);
            break;
          }
        } catch (e) {
          console.log(`❌ ${endpoint} failed`);
        }
      }
      
      if (response && response.status === true) {
        showToast("Staff added successfully");
        setShowAddModal(false);
        resetForm();
        fetchStaff();
      } else {
        const newStaff = {
          id: Date.now(),
          ...payload,
          createdAt: new Date().toISOString().split('T')[0]
        };
        setStaff([newStaff, ...staff]);
        setFilteredStaff([newStaff, ...staff]);
        showToast("Staff added locally (API unavailable)", "warning");
        setShowAddModal(false);
        resetForm();
      }
    } catch (error) {
      console.error("Add staff error:", error);
      showToast(`Failed to add staff: ${error.message}`, "error");
    } finally {
      setActionLoading(false);
    }
  };

  const updateStaff = async () => {
    if (!formData.name || !formData.email || !formData.phone || !formData.role) {
      showToast("Please fill all required fields", "error");
      return;
    }
    
    setActionLoading(true);
    try {
      const payload = {
        id: selectedStaff.id,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        role: formData.role,
        adminAccess: formData.adminAccess === "Admin" ? "1" : "0",
        status: formData.status === "Active" ? "1" : "0"
      };
      
      const endpoints = ["Staff/updateStaff", "Staff/updateAdmin", "Staff/edit", "Staff/update"];
      let response = null;
      
      for (const endpoint of endpoints) {
        try {
          response = await postData(endpoint, payload);
          if (response && response.status === true) {
            console.log(`✅ Staff updated via ${endpoint}`);
            break;
          }
        } catch (e) {
          console.log(`❌ ${endpoint} failed`);
        }
      }
      
      if (response && response.status === true) {
        showToast("Staff updated successfully");
        setShowEditModal(false);
        resetForm();
        fetchStaff();
      } else {
        const updatedStaff = staff.map(s => 
          s.id === selectedStaff.id ? { ...s, ...payload } : s
        );
        setStaff(updatedStaff);
        setFilteredStaff(updatedStaff);
        showToast("Staff updated locally (API unavailable)", "warning");
        setShowEditModal(false);
        resetForm();
      }
    } catch (error) {
      console.error("Update staff error:", error);
      showToast(`Failed to update staff: ${error.message}`, "error");
    } finally {
      setActionLoading(false);
    }
  };

  const deleteStaff = async () => {
    setActionLoading(true);
    try {
      const payload = { id: selectedStaff.id };
      const endpoints = ["Staff/deleteAdmin", "Staff/deleteStaff", "Staff/remove", "Staff/delete"];
      let response = null;
      
      for (const endpoint of endpoints) {
        try {
          console.log(`🔄 Trying delete endpoint: ${endpoint}`);
          response = await postData(endpoint, payload);
          if (response && response.status === true) {
            console.log(`✅ Staff deleted via ${endpoint}`);
            break;
          }
        } catch (e) {
          console.log(`❌ ${endpoint} failed:`, e.message);
        }
      }
      
      if (response && response.status === true) {
        showToast("Staff deleted successfully");
        setShowDeleteModal(false);
        setSelectedStaff(null);
        fetchStaff();
      } else {
        const updatedStaff = staff.filter(s => s.id !== selectedStaff.id);
        setStaff(updatedStaff);
        setFilteredStaff(updatedStaff);
        showToast("Staff deleted locally (API unavailable)", "warning");
        setShowDeleteModal(false);
        setSelectedStaff(null);
      }
    } catch (error) {
      console.error("Delete staff error:", error);
      const updatedStaff = staff.filter(s => s.id !== selectedStaff.id);
      setStaff(updatedStaff);
      setFilteredStaff(updatedStaff);
      showToast("Staff deleted locally (API error)", "warning");
      setShowDeleteModal(false);
      setSelectedStaff(null);
    } finally {
      setActionLoading(false);
    }
  };

  const toggleStaffStatus = async (staffMember) => {
    const currentStatus = staffMember.status;
    const newStatus = currentStatus === "1" ? "0" : "1";
    const displayStatus = newStatus === "1" ? "Active" : "Inactive";
    
    setActionLoading(true);
    try {
      const payload = { id: staffMember.id, status: newStatus };
      const endpoints = ["Staff/updateStatus", "Staff/toggleStatus", "Staff/changeStatus", "Staff/status", "Staff/updateAdminStatus"];
      let response = null;
      
      for (const endpoint of endpoints) {
        try {
          response = await postData(endpoint, payload);
          if (response && response.status === true) {
            console.log(`✅ Status updated via ${endpoint}`);
            break;
          }
        } catch (e) {
          console.log(`❌ ${endpoint} failed`);
        }
      }
      
      const updatedStaff = staff.map(s => 
        s.id === staffMember.id ? { ...s, status: newStatus } : s
      );
      setStaff(updatedStaff);
      setFilteredStaff(updatedStaff);
      
      if (response && response.status === true) {
        showToast(`Staff ${displayStatus.toLowerCase()}d successfully`);
      } else {
        showToast(`Staff ${displayStatus.toLowerCase()}d (offline mode)`, "warning");
      }
    } catch (error) {
      console.error("Toggle status error:", error);
      const updatedStaff = staff.map(s => 
        s.id === staffMember.id ? { ...s, status: newStatus } : s
      );
      setStaff(updatedStaff);
      setFilteredStaff(updatedStaff);
      showToast(`Staff ${displayStatus.toLowerCase()}d (offline)`, "warning");
    } finally {
      setActionLoading(false);
    }
  };

  // ─── UTILITY FUNCTIONS ─────────────────────────────────────────
  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      password: "",
      role: "",
      adminAccess: "No",
      status: "Active"
    });
    setSelectedStaff(null);
  };

  const openEditModal = (staffMember) => {
    setSelectedStaff(staffMember);
    setFormData({
      name: staffMember.name || "",
      email: staffMember.email || "",
      phone: staffMember.phone || "",
      password: "",
      role: staffMember.role || "",
      adminAccess: staffMember.adminAccess === "1" ? "Admin" : "No",
      status: staffMember.status === "1" ? "Active" : "Inactive"
    });
    setShowEditModal(true);
  };

  const openDeleteModal = (staffMember) => {
    setSelectedStaff(staffMember);
    setShowDeleteModal(true);
  };

  const exportToCSV = () => {
    const headers = ['Name', 'Email', 'Phone', 'Role', 'Admin Access', 'Status', 'Created Date'];
    const csvData = filteredStaff.map(s => [
      s.name,
      s.email,
      s.phone,
      s.role,
      s.adminAccess === "1" ? "Admin" : "No",
      s.status === "1" ? "Active" : "Inactive",
      s.createdAt || new Date().toISOString().split('T')[0]
    ]);
    
    const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `staff_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    showToast("Exported successfully");
  };

  // Pagination
  const totalPages = Math.ceil(filteredStaff.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedStaff = filteredStaff.slice(startIndex, startIndex + itemsPerPage);
  const uniqueRoles = ["all", ...new Set(staff.map(s => s.role).filter(Boolean))];

  // ─── STYLES ────────────────────────────────────────────────────
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    background: theme.surfaceLighter,
    border: `1px solid ${theme.border}`,
    borderRadius: "10px",
    fontSize: "13px",
    color: theme.textPrimary,
    outline: "none",
    transition: "all 0.2s",
    boxSizing: "border-box",
    fontFamily: "inherit",
  };

  const labelStyle = {
    display: "block",
    fontSize: "11px",
    fontWeight: 700,
    color: theme.textSecondary,
    marginBottom: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  };

  const selectStyle = {
    ...inputStyle,
    cursor: "pointer",
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: theme.background,
      fontFamily: "'DM Sans', 'Inter', sans-serif",
      padding: "20px 24px",
      transition: "background 0.3s ease",
    }}>
      <style>{`
        @keyframes slideUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.6; } }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      {/* ─── HEADER ─────────────────────────────────────────────── */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "24px",
        flexWrap: "wrap",
        gap: "16px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            background: `linear-gradient(135deg, ${theme.primary}, ${theme.primary}cc)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            boxShadow: `0 4px 12px ${theme.primary}40`,
          }}>
            <UsersIcon />
          </div>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
              <h1 style={{ fontSize: "20px", fontWeight: 700, color: theme.textPrimary, margin: 0 }}>
                Staff Management
              </h1>
              <span style={{
                fontSize: "12px",
                fontWeight: 600,
                color: theme.primary,
                background: `${theme.primary}15`,
                padding: "2px 10px",
                borderRadius: "20px",
              }}>
                {filteredStaff.length} members
              </span>
              {!apiAvailable && (
                <span style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  padding: "3px 10px",
                  borderRadius: "20px",
                  fontSize: "10px",
                  fontWeight: 700,
                  background: `${theme.warning}20`,
                  color: theme.warning,
                  border: `1px solid ${theme.warning}30`,
                }}>
                  <WarningIcon /> Offline Mode
                </span>
              )}
            </div>
            <p style={{ fontSize: "12px", color: theme.textMuted, marginTop: "4px", margin: "4px 0 0" }}>
              Manage your team members and their permissions
            </p>
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "10px 18px",
              background: theme.surfaceLighter,
              color: theme.textSecondary,
              border: `1px solid ${theme.border}`,
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "12px",
              transition: "all 0.2s",
            }}
            onClick={exportToCSV}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = theme.success;
              e.currentTarget.style.color = "#fff";
              e.currentTarget.style.borderColor = theme.success;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = theme.surfaceLighter;
              e.currentTarget.style.color = theme.textSecondary;
              e.currentTarget.style.borderColor = theme.border;
            }}
          >
            <ExportIcon /> Export CSV
          </button>
          <button
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "10px 20px",
              background: theme.primary,
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "12px",
              boxShadow: `0 4px 12px ${theme.primary}40`,
              transition: "all 0.2s",
            }}
            onClick={() => { resetForm(); setShowAddModal(true); }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
            }}
          >
            <PlusIcon /> Add Staff
          </button>
        </div>
      </div>

      {/* ─── FILTERS BAR ─────────────────────────────────────────── */}
      <div style={{
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: "14px",
        padding: "16px 20px",
        marginBottom: "20px",
        display: "flex",
        flexWrap: "wrap",
        gap: "14px",
        alignItems: "center",
      }}>
        {/* Search */}
        <div style={{ flex: 1, minWidth: "200px", position: "relative" }}>
          <span style={{
            position: "absolute",
            left: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            color: theme.textMuted,
            display: "flex",
          }}>
            <SearchIcon />
          </span>
          <input
            type="text"
            style={{
              ...inputStyle,
              paddingLeft: "36px",
              paddingRight: searchTerm ? "36px" : "12px",
            }}
            placeholder="Search by name, email or phone..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = theme.primary;
              e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = theme.border;
              e.currentTarget.style.boxShadow = "none";
            }}
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: theme.textMuted,
                padding: "4px",
                display: "flex",
              }}
            >
              <XIcon />
            </button>
          )}
        </div>

        {/* Role Filter */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontSize: "11px", color: theme.textMuted, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Role:</span>
          <select
            style={{ ...selectStyle, width: "auto", minWidth: "130px" }}
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="all">All Roles</option>
            {uniqueRoles.filter(r => r !== "all").map(role => (
              <option key={role} value={role}>{role}</option>
            ))}
          </select>
        </div>

        {/* Admin Filter */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontSize: "11px", color: theme.textMuted, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Admin:</span>
          <select
            style={{ ...selectStyle, width: "auto", minWidth: "120px" }}
            value={selectedAdmin}
            onChange={(e) => setSelectedAdmin(e.target.value)}
          >
            <option value="all">All</option>
            <option value="Admin">Admin Access</option>
            <option value="No">No Access</option>
          </select>
        </div>

        {/* Status Filter */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontSize: "11px", color: theme.textMuted, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Status:</span>
          <select
            style={{ ...selectStyle, width: "auto", minWidth: "120px" }}
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="all">All Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>

      {/* ─── TABLE ───────────────────────────────────────────────── */}
      <div style={{
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: `0 4px 12px ${theme.primary}08`,
      }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "800px" }}>
            <thead>
              <tr>
                {["#", "Name", "Email", "Phone", "Role", "Admin", "Status", "Actions"].map((h) => (
                  <th key={h} style={{
                    padding: "14px 12px",
                    textAlign: "left",
                    fontSize: "11px",
                    fontWeight: 700,
                    color: theme.primary,
                    borderBottom: `1px solid ${theme.border}`,
                    background: theme.surfaceLighter,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 5 }).map((_, i) => (
                  <tr key={i}>
                    {Array.from({ length: 8 }).map((_, j) => (
                      <td key={j} style={{ padding: "12px", borderBottom: `1px solid ${theme.border}` }}>
                        <div style={{
                          height: "12px",
                          background: theme.border,
                          borderRadius: "4px",
                          width: j === 0 ? "30px" : "80%",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : paginatedStaff.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center", padding: "60px" }}>
                    <div style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      background: `${theme.primary}15`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      color: theme.primary,
                    }}>
                      <UserIcon />
                    </div>
                    <h3 style={{ color: theme.textPrimary, marginBottom: "8px", fontSize: "16px", fontWeight: 600 }}>
                      {searchTerm || selectedRole !== "all" || selectedStatus !== "all" || selectedAdmin !== "all" 
                        ? "No Matching Staff" : "No Staff Members"}
                    </h3>
                    <p style={{ color: theme.textMuted, fontSize: "13px", margin: 0 }}>
                      {searchTerm || selectedRole !== "all" || selectedStatus !== "all" || selectedAdmin !== "all" 
                        ? "Try adjusting your filters" : "Add your first team member to get started"}
                    </p>
                  </td>
                </tr>
              ) : (
                paginatedStaff.map((staffMember, idx) => {
                  const displayStatus = staffMember.status === "1" ? "Active" : "Inactive";
                  const displayAdmin = staffMember.adminAccess === "1" ? "Admin" : "No";
                  const isActive = staffMember.status === "1";
                  const isAdmin = staffMember.adminAccess === "1";
                  
                  return (
                    <tr
                      key={staffMember.id}
                      style={{ transition: "background 0.15s ease" }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surfaceLighter)}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                    >
                      <td style={{
                        padding: "12px",
                        borderBottom: `1px solid ${theme.border}`,
                        fontSize: "12px",
                        color: theme.textMuted,
                        fontFamily: "monospace",
                        fontWeight: 700,
                      }}>
                        {startIndex + idx + 1}
                      </td>
                      <td style={{
                        padding: "12px",
                        borderBottom: `1px solid ${theme.border}`,
                        fontSize: "13px",
                        color: theme.textPrimary,
                        fontWeight: 700,
                      }}>
                        {staffMember.name}
                      </td>
                      <td style={{
                        padding: "12px",
                        borderBottom: `1px solid ${theme.border}`,
                        fontSize: "12px",
                        color: theme.textSecondary,
                      }}>
                        {staffMember.email}
                      </td>
                      <td style={{
                        padding: "12px",
                        borderBottom: `1px solid ${theme.border}`,
                        fontSize: "12px",
                        color: theme.textSecondary,
                        fontFamily: "monospace",
                      }}>
                        {staffMember.phone}
                      </td>
                      <td style={{
                        padding: "12px",
                        borderBottom: `1px solid ${theme.border}`,
                      }}>
                        <span style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                          padding: "4px 10px",
                          borderRadius: "20px",
                          fontSize: "11px",
                          fontWeight: 600,
                          background: `${theme.primary}15`,
                          color: theme.primary,
                        }}>
                          {staffMember.role}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px",
                        borderBottom: `1px solid ${theme.border}`,
                      }}>
                        {isAdmin ? (
                          <span style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            color: theme.success,
                            fontWeight: 700,
                            fontSize: "12px",
                          }}>
                            ✓ Admin
                          </span>
                        ) : (
                          <span style={{ color: theme.textMuted, fontSize: "12px" }}>No</span>
                        )}
                      </td>
                      <td style={{
                        padding: "12px",
                        borderBottom: `1px solid ${theme.border}`,
                      }}>
                        <button
                          onClick={() => toggleStaffStatus(staffMember)}
                          disabled={actionLoading}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "11px",
                            fontWeight: 600,
                            background: isActive ? `${theme.success}1a` : `${theme.textMuted}1a`,
                            color: isActive ? theme.success : theme.textMuted,
                            border: `1px solid ${isActive ? theme.success : theme.textMuted}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            transition: "all 0.2s",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = isActive ? `${theme.success}30` : `${theme.textMuted}30`;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = isActive ? `${theme.success}1a` : `${theme.textMuted}1a`;
                          }}
                        >
                          <div style={{
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            background: isActive ? theme.success : theme.textMuted,
                          }} />
                          {displayStatus}
                        </button>
                      </td>
                      <td style={{
                        padding: "12px",
                        borderBottom: `1px solid ${theme.border}`,
                      }}>
                        <div style={{ display: "flex", gap: "6px" }}>
                          <button
                            onClick={() => openEditModal(staffMember)}
                            style={{
                              padding: "6px 10px",
                              borderRadius: "6px",
                              background: `${theme.primary}15`,
                              border: `1px solid ${theme.primary}30`,
                              cursor: "pointer",
                              fontSize: "11px",
                              fontWeight: 600,
                              color: theme.primary,
                              transition: "all 0.2s",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.primary}25`)}
                            onMouseLeave={(e) => (e.currentTarget.style.background = `${theme.primary}15`)}
                          >
                            <EditIcon /> Edit
                          </button>
                          <button
                            onClick={() => openDeleteModal(staffMember)}
                            style={{
                              padding: "6px 10px",
                              borderRadius: "6px",
                              background: `${theme.error || theme.danger}15`,
                              border: `1px solid ${theme.error || theme.danger}30`,
                              cursor: "pointer",
                              fontSize: "11px",
                              fontWeight: 600,
                              color: theme.error || theme.danger,
                              transition: "all 0.2s",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = theme.error || theme.danger;
                              e.currentTarget.style.color = "#fff";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = `${theme.error || theme.danger}15`;
                              e.currentTarget.style.color = theme.error || theme.danger;
                            }}
                          >
                            <DeleteIcon /> Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "14px 20px",
            borderTop: `1px solid ${theme.border}`,
            background: theme.surfaceLighter,
            flexWrap: "wrap",
            gap: "12px",
          }}>
            <span style={{ fontSize: "12px", color: theme.textSecondary }}>
              Showing <strong style={{ color: theme.textPrimary }}>{startIndex + 1}</strong> to <strong style={{ color: theme.textPrimary }}>{Math.min(startIndex + itemsPerPage, filteredStaff.length)}</strong> of <strong style={{ color: theme.textPrimary }}>{filteredStaff.length}</strong> entries
            </span>
            <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
              <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                style={{
                  padding: "6px 14px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.border}`,
                  background: theme.surface,
                  color: currentPage === 1 ? theme.textMuted : theme.textSecondary,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontSize: "12px",
                  fontWeight: 500,
                  opacity: currentPage === 1 ? 0.5 : 1,
                  transition: "all 0.2s",
                }}
              >
                ← Previous
              </button>
              <span style={{
                padding: "6px 14px",
                borderRadius: "6px",
                background: theme.primary,
                color: "#fff",
                fontSize: "12px",
                fontWeight: 700,
              }}>
                {currentPage} / {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
                style={{
                  padding: "6px 14px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.border}`,
                  background: theme.surface,
                  color: currentPage === totalPages ? theme.textMuted : theme.textSecondary,
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  fontSize: "12px",
                  fontWeight: 500,
                  opacity: currentPage === totalPages ? 0.5 : 1,
                  transition: "all 0.2s",
                }}
              >
                Next →
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ─── ADD MODAL ───────────────────────────────────────────── */}
      {showAddModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            background: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            animation: "fadeIn 0.2s ease-out",
          }}
          onClick={() => setShowAddModal(false)}
        >
          <div
            style={{
              background: theme.surface,
              border: `1px solid ${theme.border}`,
              borderRadius: "20px",
              width: "500px",
              maxWidth: "90vw",
              maxHeight: "85vh",
              overflow: "auto",
              boxShadow: `0 25px 60px ${theme.primary}30`,
              animation: "slideUp 0.3s ease-out",
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px 24px",
              borderBottom: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
            }}>
              <h2 style={{ fontSize: "18px", fontWeight: 700, color: theme.textPrimary, margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                <PlusIcon /> Add New Staff
              </h2>
              <button
                onClick={() => setShowAddModal(false)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: theme.textMuted,
                  padding: "6px",
                  display: "flex",
                  borderRadius: "8px",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = `${theme.error || theme.danger}15`;
                  e.currentTarget.style.color = theme.error || theme.danger;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "none";
                  e.currentTarget.style.color = theme.textMuted;
                }}
              >
                <CloseIcon />
              </button>
            </div>

            {/* Modal Body */}
            <div style={{ padding: "24px" }}>
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Name <span style={{ color: theme.error || theme.danger }}>*</span></label>
                <input type="text" style={inputStyle} value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  placeholder="Enter full name"
                  onFocus={(e) => { e.currentTarget.style.borderColor = theme.primary; e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Email <span style={{ color: theme.error || theme.danger }}>*</span></label>
                <input type="email" style={inputStyle} value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  placeholder="Enter email address"
                  onFocus={(e) => { e.currentTarget.style.borderColor = theme.primary; e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Phone <span style={{ color: theme.error || theme.danger }}>*</span></label>
                <input type="tel" style={inputStyle} value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  placeholder="Enter phone number"
                  onFocus={(e) => { e.currentTarget.style.borderColor = theme.primary; e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Password</label>
                <input type="password" style={inputStyle} value={formData.password}
                  onChange={(e) => setFormData({...formData, password: e.target.value})}
                  placeholder="Enter password (optional)"
                  onFocus={(e) => { e.currentTarget.style.borderColor = theme.primary; e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Role <span style={{ color: theme.error || theme.danger }}>*</span></label>
                <select style={selectStyle} value={formData.role}
                  onChange={(e) => setFormData({...formData, role: e.target.value})}
                >
                  <option value="">Select Role</option>
                  {roles.map(role => (
                    <option key={role} value={role}>{role}</option>
                  ))}
                </select>
              </div>

              {/* Admin Access - Card Style */}
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Admin Access</label>
                <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                  <label style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    color: theme.textPrimary,
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: `1px solid ${formData.adminAccess === "Yes" ? theme.success : theme.border}`,
                    background: formData.adminAccess === "Yes" ? `${theme.success}15` : "transparent",
                    transition: "all 0.2s",
                    fontWeight: 500,
                  }}>
                    <input type="radio" value="Yes" checked={formData.adminAccess === "Yes"}
                      onChange={(e) => setFormData({...formData, adminAccess: e.target.value})}
                      style={{ accentColor: theme.success }}
                    /> ✓ Yes
                  </label>
                  <label style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    color: theme.textPrimary,
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: `1px solid ${formData.adminAccess === "No" ? theme.textMuted : theme.border}`,
                    background: formData.adminAccess === "No" ? `${theme.textMuted}15` : "transparent",
                    transition: "all 0.2s",
                    fontWeight: 500,
                  }}>
                    <input type="radio" value="No" checked={formData.adminAccess === "No"}
                      onChange={(e) => setFormData({...formData, adminAccess: e.target.value})}
                      style={{ accentColor: theme.textMuted }}
                    /> ✗ No
                  </label>
                </div>
              </div>

              {/* Status - Card Style */}
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Status</label>
                <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                  <label style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    color: theme.textPrimary,
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: `1px solid ${formData.status === "Active" ? theme.success : theme.border}`,
                    background: formData.status === "Active" ? `${theme.success}15` : "transparent",
                    transition: "all 0.2s",
                    fontWeight: 500,
                  }}>
                    <input type="radio" value="Active" checked={formData.status === "Active"}
                      onChange={(e) => setFormData({...formData, status: e.target.value})}
                      style={{ accentColor: theme.success }}
                    /> 🟢 Active
                  </label>
                  <label style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    color: theme.textPrimary,
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: `1px solid ${formData.status === "Inactive" ? theme.textMuted : theme.border}`,
                    background: formData.status === "Inactive" ? `${theme.textMuted}15` : "transparent",
                    transition: "all 0.2s",
                    fontWeight: 500,
                  }}>
                    <input type="radio" value="Inactive" checked={formData.status === "Inactive"}
                      onChange={(e) => setFormData({...formData, status: e.target.value})}
                      style={{ accentColor: theme.textMuted }}
                    /> ⚫ Inactive
                  </label>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div style={{
              display: "flex",
              gap: "12px",
              padding: "16px 24px",
              borderTop: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
            }}>
              <button
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "10px",
                  background: "transparent",
                  border: `1px solid ${theme.border}`,
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: theme.textPrimary,
                  transition: "all 0.2s",
                }}
                onClick={() => setShowAddModal(false)}
                onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surface)}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                Cancel
              </button>
              <button
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "10px",
                  background: actionLoading ? theme.textMuted : theme.primary,
                  border: "none",
                  cursor: actionLoading ? "not-allowed" : "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#fff",
                  boxShadow: actionLoading ? "none" : `0 4px 12px ${theme.primary}40`,
                  transition: "all 0.2s",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                }}
                onClick={addStaff}
                disabled={actionLoading}
                onMouseEnter={(e) => {
                  if (!actionLoading) {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = actionLoading ? "none" : `0 4px 12px ${theme.primary}40`;
                }}
              >
                {actionLoading ? "⏳ Adding..." : "+ Add Staff"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── EDIT MODAL ──────────────────────────────────────────── */}
      {showEditModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            background: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            animation: "fadeIn 0.2s ease-out",
          }}
          onClick={() => setShowEditModal(false)}
        >
          <div
            style={{
              background: theme.surface,
              border: `1px solid ${theme.border}`,
              borderRadius: "20px",
              width: "500px",
              maxWidth: "90vw",
              maxHeight: "85vh",
              overflow: "auto",
              boxShadow: `0 25px 60px ${theme.primary}30`,
              animation: "slideUp 0.3s ease-out",
            }}
            onClick={e => e.stopPropagation()}
          >
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px 24px",
              borderBottom: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
            }}>
              <h2 style={{ fontSize: "18px", fontWeight: 700, color: theme.textPrimary, margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                <EditIcon /> Edit Staff
              </h2>
              <button onClick={() => setShowEditModal(false)}
                style={{ background: "none", border: "none", cursor: "pointer", color: theme.textMuted, padding: "6px", display: "flex", borderRadius: "8px", transition: "all 0.2s" }}
                onMouseEnter={(e) => { e.currentTarget.style.background = `${theme.error || theme.danger}15`; e.currentTarget.style.color = theme.error || theme.danger; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = theme.textMuted; }}
              >
                <CloseIcon />
              </button>
            </div>

            <div style={{ padding: "24px" }}>
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Name <span style={{ color: theme.error || theme.danger }}>*</span></label>
                <input type="text" style={inputStyle} value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  onFocus={(e) => { e.currentTarget.style.borderColor = theme.primary; e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; }}
                />
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Email <span style={{ color: theme.error || theme.danger }}>*</span></label>
                <input type="email" style={inputStyle} value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  onFocus={(e) => { e.currentTarget.style.borderColor = theme.primary; e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; }}
                />
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Phone <span style={{ color: theme.error || theme.danger }}>*</span></label>
                <input type="tel" style={inputStyle} value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  onFocus={(e) => { e.currentTarget.style.borderColor = theme.primary; e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.boxShadow = "none"; }}
                />
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Role <span style={{ color: theme.error || theme.danger }}>*</span></label>
                <select style={selectStyle} value={formData.role}
                  onChange={(e) => setFormData({...formData, role: e.target.value})}
                >
                  {roles.map(role => (
                    <option key={role} value={role}>{role}</option>
                  ))}
                </select>
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Admin Access</label>
                <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                  <label style={{
                    flex: 1, display: "flex", alignItems: "center", gap: "8px", cursor: "pointer",
                    fontSize: "13px", color: theme.textPrimary, padding: "10px 14px", borderRadius: "10px",
                    border: `1px solid ${formData.adminAccess === "Admin" ? theme.success : theme.border}`,
                    background: formData.adminAccess === "Admin" ? `${theme.success}15` : "transparent",
                    transition: "all 0.2s", fontWeight: 500,
                  }}>
                    <input type="radio" value="Admin" checked={formData.adminAccess === "Admin"}
                      onChange={(e) => setFormData({...formData, adminAccess: e.target.value})}
                      style={{ accentColor: theme.success }}
                    /> ✓ Admin
                  </label>
                  <label style={{
                    flex: 1, display: "flex", alignItems: "center", gap: "8px", cursor: "pointer",
                    fontSize: "13px", color: theme.textPrimary, padding: "10px 14px", borderRadius: "10px",
                    border: `1px solid ${formData.adminAccess === "No" ? theme.textMuted : theme.border}`,
                    background: formData.adminAccess === "No" ? `${theme.textMuted}15` : "transparent",
                    transition: "all 0.2s", fontWeight: 500,
                  }}>
                    <input type="radio" value="No" checked={formData.adminAccess === "No"}
                      onChange={(e) => setFormData({...formData, adminAccess: e.target.value})}
                      style={{ accentColor: theme.textMuted }}
                    /> ✗ No
                  </label>
                </div>
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Status</label>
                <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                  <label style={{
                    flex: 1, display: "flex", alignItems: "center", gap: "8px", cursor: "pointer",
                    fontSize: "13px", color: theme.textPrimary, padding: "10px 14px", borderRadius: "10px",
                    border: `1px solid ${formData.status === "Active" ? theme.success : theme.border}`,
                    background: formData.status === "Active" ? `${theme.success}15` : "transparent",
                    transition: "all 0.2s", fontWeight: 500,
                  }}>
                    <input type="radio" value="Active" checked={formData.status === "Active"}
                      onChange={(e) => setFormData({...formData, status: e.target.value})}
                      style={{ accentColor: theme.success }}
                    /> 🟢 Active
                  </label>
                  <label style={{
                    flex: 1, display: "flex", alignItems: "center", gap: "8px", cursor: "pointer",
                    fontSize: "13px", color: theme.textPrimary, padding: "10px 14px", borderRadius: "10px",
                    border: `1px solid ${formData.status === "Inactive" ? theme.textMuted : theme.border}`,
                    background: formData.status === "Inactive" ? `${theme.textMuted}15` : "transparent",
                    transition: "all 0.2s", fontWeight: 500,
                  }}>
                    <input type="radio" value="Inactive" checked={formData.status === "Inactive"}
                      onChange={(e) => setFormData({...formData, status: e.target.value})}
                      style={{ accentColor: theme.textMuted }}
                    /> ⚫ Inactive
                  </label>
                </div>
              </div>
            </div>

            <div style={{
              display: "flex", gap: "12px", padding: "16px 24px",
              borderTop: `1px solid ${theme.border}`, background: theme.surfaceLighter,
            }}>
              <button
                style={{ flex: 1, padding: "10px", borderRadius: "10px", background: "transparent", border: `1px solid ${theme.border}`, cursor: "pointer", fontSize: "13px", fontWeight: 500, color: theme.textPrimary, transition: "all 0.2s" }}
                onClick={() => setShowEditModal(false)}
                onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surface)}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                Cancel
              </button>
              <button
                style={{
                  flex: 1, padding: "10px", borderRadius: "10px",
                  background: actionLoading ? theme.textMuted : theme.primary,
                  border: "none", cursor: actionLoading ? "not-allowed" : "pointer",
                  fontSize: "13px", fontWeight: 600, color: "#fff",
                  boxShadow: actionLoading ? "none" : `0 4px 12px ${theme.primary}40`,
                  transition: "all 0.2s",
                }}
                onClick={updateStaff}
                disabled={actionLoading}
                onMouseEnter={(e) => { if (!actionLoading) { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`; } }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = actionLoading ? "none" : `0 4px 12px ${theme.primary}40`; }}
              >
                {actionLoading ? "⏳ Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── DELETE MODAL ────────────────────────────────────────── */}
      {showDeleteModal && selectedStaff && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            background: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            animation: "fadeIn 0.2s ease-out",
          }}
          onClick={() => setShowDeleteModal(false)}
        >
          <div
            style={{
              background: theme.surface,
              border: `1px solid ${theme.border}`,
              borderRadius: "20px",
              width: "400px",
              maxWidth: "90vw",
              boxShadow: `0 25px 60px ${theme.primary}30`,
              animation: "slideUp 0.3s ease-out",
              overflow: "hidden",
            }}
            onClick={e => e.stopPropagation()}
          >
            <div style={{
              padding: "24px",
              textAlign: "center",
            }}>
              <div style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                background: `${theme.error || theme.danger}15`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                color: theme.error || theme.danger,
              }}>
                <DeleteIcon />
              </div>
              <h2 style={{ fontSize: "18px", fontWeight: 700, color: theme.textPrimary, margin: "0 0 8px" }}>
                Confirm Delete
              </h2>
              <p style={{ fontSize: "13px", color: theme.textMuted, margin: 0, lineHeight: 1.6 }}>
                Are you sure you want to delete <strong style={{ color: theme.textPrimary }}>{selectedStaff.name}</strong>? This action cannot be undone.
              </p>
            </div>
            <div style={{
              display: "flex",
              gap: "12px",
              padding: "16px 24px",
              borderTop: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
            }}>
              <button
                style={{ flex: 1, padding: "10px", borderRadius: "10px", background: "transparent", border: `1px solid ${theme.border}`, cursor: "pointer", fontSize: "13px", fontWeight: 500, color: theme.textPrimary, transition: "all 0.2s" }}
                onClick={() => setShowDeleteModal(false)}
                onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surface)}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                Cancel
              </button>
              <button
                style={{
                  flex: 1, padding: "10px", borderRadius: "10px",
                  background: actionLoading ? theme.textMuted : (theme.error || theme.danger),
                  border: "none", cursor: actionLoading ? "not-allowed" : "pointer",
                  fontSize: "13px", fontWeight: 600, color: "#fff",
                  boxShadow: actionLoading ? "none" : `0 4px 12px ${theme.error || theme.danger}40`,
                  transition: "all 0.2s",
                }}
                onClick={deleteStaff}
                disabled={actionLoading}
                onMouseEnter={(e) => { if (!actionLoading) { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = `0 6px 16px ${theme.error || theme.danger}60`; } }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = actionLoading ? "none" : `0 4px 12px ${theme.error || theme.danger}40`; }}
              >
                {actionLoading ? "⏳ Deleting..." : "🗑️ Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── TOAST ───────────────────────────────────────────────── */}
      {toast && (
        <div style={{
          position: "fixed",
          bottom: "24px",
          right: "24px",
          zIndex: 1100,
          padding: "12px 20px",
          borderRadius: "12px",
          fontSize: "13px",
          fontWeight: 500,
          animation: "slideUp 0.25s ease",
          background: theme.surface,
          border: `1px solid ${
            toast.type === "error" ? (theme.error || theme.danger) : 
            toast.type === "warning" ? theme.warning : 
            theme.success
          }40`,
          color: toast.type === "error" ? (theme.error || theme.danger) : 
                 toast.type === "warning" ? theme.warning : 
                 theme.success,
          boxShadow: `0 8px 32px ${theme.primary}20`,
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}>
          <div style={{
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            background: toast.type === "error" ? (theme.error || theme.danger) : 
                       toast.type === "warning" ? theme.warning : 
                       theme.success,
          }} />
          {toast.message}
        </div>
      )}
    </div>
  );
};

export default StaffTable;